import TutorBioTabs from './TutorBioTabs';

export default TutorBioTabs;
